import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "./index.css";
import "flowbite";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// layouts
import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";
import Student from "layouts/Student.js";
import LabIncharge from "layouts/LabIncharge.js";

// views without layouts
import Landing from "views/Landing.js";
import Profile from "views/Profile.js";
import Login from "views/auth/Login.js";
import HomePage from "views/Homepage/HomePage";

// New Pages
import About from "views/Pages/About";
import MPDI from "views/Pages/MPDI";
import IPD from "views/Pages/IPD";
import StudentClubs from "views/Pages/StudentClubs";
import InnovationAwards from "views/Pages/InnovationAwards";
import Innovation from "views/Pages/Innovation";
import StudentInnovationSchemes from "views/Pages/StudentInnovationSchemes";
import Blog from "views/Pages/Blog";

import BlogDetail from "views/Pages/BlogDetail";
import GalleryList from "views/Pages/GalleryList";
import GalleryDetail from "views/Pages/GalleryDetail";
import GetInvolved from "views/Pages/GetInvolved";
import Contact from "views/Pages/Contact";
import JHSIC from "views/Pages/JHSIC";
import SocialSidebar from "components/SocialSidebar";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <SocialSidebar />
    <Routes>
      {/* Routes with layouts */}
      <Route path="/admin/*" element={<Admin />} />
      <Route path="/auth/*" element={<Auth />} />
      <Route path="/student/*" element={<Student />} />
      <Route path="/labincharge/*" element={<LabIncharge />} />

      <Route path="/home" element={<HomePage />} />

      {/* New Page Routes */}
      <Route path="/about" element={<About />} />
      <Route path="/programs" element={<Navigate to="/programs/mpdi" replace />} />
      <Route path="/programs/mpdi" element={<MPDI />} />
      <Route path="/programs/ipd" element={<IPD />} />
      <Route path="/programs/clubs" element={<StudentClubs />} />
      <Route path="/programs/awards" element={<InnovationAwards />} />
      <Route path="/innovation" element={<Innovation />} />
      <Route path="/innovation/student-schemes" element={<StudentInnovationSchemes />} />

      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogDetail />} />
      <Route path="/gallery" element={<GalleryList />} />
      <Route path="/gallery/:id" element={<GalleryDetail />} />
      <Route path="/get-involved" element={<GetInvolved />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/jhsic" element={<JHSIC />} />

      <Route path="/landing" element={<Landing />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<Navigate to="/home" replace />} />

      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  </BrowserRouter>
);